export function formatNumber(number: number) {
  if (number === Math.floor(number)) {
    return Math.floor(number);
  } else {
    return number.toFixed(1);
  }
}
